import script from "./ButtonSocial.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSocial.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSocial.vue?vue&type=style&index=0&id=c8a457ca&lang=scss"

const __exports__ = script;

export default __exports__